import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Devices from "@/pages/Devices";
import Accounts from "@/pages/Accounts";
import Personas from "@/pages/Personas";
import Proxies from "@/pages/Proxies";
import Videos from "@/pages/Videos";
import Schedule from "@/pages/Schedule";
import Streams from "@/pages/Streams";
import Warmup from "@/pages/Warmup";
import Comments from "@/pages/Comments";
import Logs from "@/pages/Logs";
import Analytics from "@/pages/Analytics";
import Alerts from "@/pages/Alerts";
import Settings from "@/pages/Settings";
import { auth, api } from "@/lib/api";

function Protected({ children }) {
  const [state, setState] = useState("checking"); // checking | ok | denied
  const location = useLocation();
  useEffect(() => {
    if (!auth.getToken()) { setState("denied"); return; }
    api.verify().then(() => setState("ok")).catch(() => { auth.clear(); setState("denied"); });
  }, [location.pathname]);
  if (state === "checking") {
    return <div className="min-h-screen flex items-center justify-center text-slate-400 text-sm">…</div>;
  }
  if (state === "denied") return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="devices" element={<Devices />} />
            <Route path="accounts" element={<Accounts />} />
            <Route path="personas" element={<Personas />} />
            <Route path="proxies" element={<Proxies />} />
            <Route path="videos" element={<Videos />} />
            <Route path="schedule" element={<Schedule />} />
            <Route path="streams" element={<Streams />} />
            <Route path="warmup" element={<Warmup />} />
            <Route path="comments" element={<Comments />} />
            <Route path="logs" element={<Logs />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="alerts" element={<Alerts />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}
